export const DIFFICULTY_LEVELS = {
  facile: {
    id: 'facile',
    name: 'Facile',
    description: 'Revenus majorés, charges réduites, événements plus cléments.',
    color: 'emerald',
    revenueMultiplier: 1.25,
    expenseMultiplier: 0.80,
    // 02/06/2026 — Rééquilibrage : événements ponctuels divisés par 2.
    eventProbMultiplier: 0.30,
    startingTreasury: 12000,
    loanAmount: 20000,
    reputationGain: 0.3,
    reputationLoss: 0.05,
  },
  normal: {
    id: 'normal',
    name: 'Normal',
    description: 'L\'expérience standard. Équilibrée et réaliste.',
    color: 'blue',
    revenueMultiplier: 1.0,
    expenseMultiplier: 1.0,
    // 02/06/2026 — Rééquilibrage : les événements aléatoires étaient trop
    // omniprésents (le joueur en encaissait 1-2/semaine). Réduit à 0.5 pour
    // mettre en avant la planification long-terme et les bonus des supports.
    eventProbMultiplier: 0.50,
    startingTreasury: 8000,
    loanAmount: 15000,
    reputationGain: 0.2,
    reputationLoss: 0.1,
  },
  difficile: {
    id: 'difficile',
    name: 'Difficile',
    description: 'Revenus réduits, charges majorées, événements fréquents.',
    color: 'red',
    revenueMultiplier: 0.80,
    expenseMultiplier: 1.25,
    // 02/06/2026 — Rééquilibrage : difficile conserve une pression
    // d'événements claire mais sans noyer le joueur (1.5 → 0.9).
    eventProbMultiplier: 0.90,
    startingTreasury: 5000,
    loanAmount: 12000,
    reputationGain: 0.15,
    reputationLoss: 0.2,
  },
};
